import { render, staticRenderFns } from "./cancleModal.vue?vue&type=template&id=0dc3beff&scoped=true"
import script from "./cancleModal.vue?vue&type=script&lang=js"
export * from "./cancleModal.vue?vue&type=script&lang=js"
import style0 from "./cancleModal.vue?vue&type=style&index=0&id=0dc3beff&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc3beff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/xrUxRsdL/0/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dc3beff')) {
      api.createRecord('0dc3beff', component.options)
    } else {
      api.reload('0dc3beff', component.options)
    }
    module.hot.accept("./cancleModal.vue?vue&type=template&id=0dc3beff&scoped=true", function () {
      api.rerender('0dc3beff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modal/cancleModal.vue"
export default component.exports